import React, { Component } from "react";
import QRCode from "qrcode.react";
import "./Report.css";
import _ from "lodash";
import Api from "../../api/api";

import intl from 'react-intl-universal';
import Apiwx from '../../api/wxapi';
import '../person/config'

import { inject, observer } from 'mobx-react';

import Tyre_dot from './ReportDot'

import ReportCormach from './ReportCormach'
import ReportSa from './ReportSa'
import ReportDill from './ReportDill'
import ReportDach from './ReportDach'
import ReportHonda from './ReportHonda'


@inject('store')
@observer
export default class Report extends Component {
  constructor(props) {
    super();
    this.state = {
      report: null,
      language: 'zh',
      loading: true,
      showMotor: true,
      showControl: true,
      showSum: true,
      cormach: false,
    };

    this.noteArr = [{ name: intl.get('txt_haoxiaoxi'), color: '#16a11d' },
        { name: intl.get('txt_vedi_Note'), color: '#fecd01' },
        { name: intl.get('txt_replace1'), color: '#fe4019' }]
  }
  returnLanguage ()  {
    let jsSrc = this.getQueryString('lang');
    if (!jsSrc) 
      return jsSrc
    // alert(jsSrc)
    if (jsSrc.indexOf('zh-CN') >= 0 || jsSrc.indexOf('zh-TW') >= 0) {
      return jsSrc
    }
    else
    // if (jsSrc.indexOf('zh-HK') >= 0) {
    //   return jsSrc
    // }
    // else
    if (jsSrc.indexOf('zh') >= 0 ) {
      return 'zh'
    }
    else if (jsSrc.indexOf('lt') >= 0 || jsSrc.indexOf('it') >= 0) {
      return 'it'
    }
    else if (jsSrc.indexOf('ge') >= 0 || jsSrc.indexOf('de') >= 0) {
      return 'de'
    }
    else if (jsSrc.indexOf('ma') >= 0 || jsSrc.indexOf('ms') >= 0) {
      return 'ms'
    }
    else if (jsSrc.indexOf('jp') >= 0 || jsSrc.indexOf('ja') >= 0) {
      return 'ja'
    }
    else if (jsSrc.indexOf('po') >= 0 || jsSrc.indexOf('pl') >= 0) {
      return 'pl'
    }
    else if (jsSrc.indexOf('por') >= 0 || jsSrc.indexOf('pt') >= 0) {
      return 'pt'
    }
    else if (jsSrc.indexOf('dk') >= 0 || jsSrc.indexOf('da') >= 0) {
      return 'da'
    }
    else if (jsSrc.indexOf('es') >= 0 || jsSrc.indexOf('es') >= 0) {
      return 'es'
    }
    else if (jsSrc.indexOf('en-GB') >= 0 || jsSrc.indexOf('en-US') >= 0 || jsSrc.indexOf('en-CA') >= 0) {
      return jsSrc
    }else if (jsSrc.indexOf('ko') >= 0 || jsSrc.indexOf('korean') >= 0) {
      return 'ko'
    }
    else {
      return 'en'
    }
  };
  componentDidMount() {
    this.getRecordDetail();
    let lang = this.returnLanguage();
    intl.options.currentLocale = lang ? lang : intl.options.currentLocale
    lang = intl.options.currentLocale
    // alert(intl.options.currentLocale)
    // if (lang.includes("en")) {
    //   alert("includes is working")
    // }
    this.forceUpdate()
    // if (this.state.report) {
      this.setState({
        loading: false,
      });
    // }

    this.noteArr = [{ name: intl.get('txt_haoxiaoxi'), color: '#16a11d' },
        { name: intl.get('txt_vedi_Note'), color: '#fecd01' },
        { name: intl.get('txt_replace1'), color: '#fe4019' }]
  }

  render() {
    if (this.state.loading === true){
      return(
      <div className="empty-loading-page">
        <div className="lds-ripple page-centered">loading ...</div>
      </div>
      );
    }else {
      if (this.state.report) {
        var {
          brake_type,
          car,
          plate_no,
          device_time,
          odometer,
          store,
          store_address,
          model_name,
          device_number,
          conclusion,
          suggestion,
          wear_lf_degree,
          wear_rf_degree,
          wear_lb_degree,
          wear_rb_degree,
          ecc_wear_lf_degree,
          ecc_wear_rf_degree,
          ecc_wear_lb_degree,
          ecc_wear_rb_degree,
          transposition,
          wear_threshold,
          wear_lf_data,
          wear_rf_data,
          wear_lb_data,
          wear_rb_data,
          wear_coordinate_max,
          purpose,
          remark,
          tyre_lb,
          tyre_lf,
          tyre_rb,
          tyre_rf,
          uuid,
          trauma_lf_img,
          trauma_rf_img,
          trauma_lb_img,
          trauma_rb_img,
          language,
          last_wear,
          inspector,//技师名字
          inspector_number,
          wear_lf_value,
          wear_lb_value,
          wear_rf_value,
          wear_rb_value,
          logo,
          model_number,   
          create_time,
          tyreunit,
          season,
          wear_threshold,
          mobile,
          goodsname,
          tireremark,
          bolt,
          mileageUnit,
          inspections,
        } = this.state.report;
      }
      let purposeStr = purpose ? this.getpurposeStr(purpose) : '-';
      let lang = intl.options.currentLocale;    
      
      mileageUnit = mileageUnit ? mileageUnit : 'KM';
      let autogem = false
      if (model_number && model_number.includes("Autogem")){
        const d1 = new Date("12/11/2024 23:59:59");
        const d2 = new Date(create_time);
        if (d2 < d1)
          mileageUnit = 'Miles';
        autogem = true;
      }      
        
      let need_wheel_align= ecc_wear_lf_degree!="low" && ecc_wear_lb_degree!="low" &&ecc_wear_rf_degree!="low" &&ecc_wear_rb_degree!="low" ?false : true

      // tyreunit = model_number === 'Autogem.tyrescan.ts005' ? 'unit_in' : tyreunit
      //KM to Miles 1 km = 0.6214 miles, need not transfer, the input is miles
      // odometer = model_number === 'Autogem.tyrescan.ts005' ? odometer*0.6214: odometer

      //specified model setting 
      let generalModel = model_number !== 'taiwan.tyrescan.ts004' && !this.state.cormach && model_number !== 'sa.tyrescan.ts004' 
      && model_number !== 'dill.tyrescan.ts004' && model_number !== 'dach.tyrescan.ts004' && model_number !== 'dach.tyrescan.ts005' 
      // && model_number !== 'honda.philippine.ts005' 
      && model_number !== 'reinheimer.tyrescan.ts004' && model_number !== 'reinheimer.tyrescan.ts005' 

      return (
        <div className="report">
          {model_number === 'taiwan.tyrescan.ts004' && this.taiwanUi()}
          {(this.state.cormach) && <ReportCormach report={this.state.report}></ReportCormach>}
          {model_number === 'sa.tyrescan.ts004' && <ReportSa report={this.state.report}></ReportSa>}
          {model_number === 'dill.tyrescan.ts004' && <ReportDill report={this.state.report}></ReportDill>}
          {(model_number === 'dach.tyrescan.ts004'
          || model_number === 'dach.tyrescan.ts005'
          || model_number === 'reinheimer.tyrescan.ts004'
          || model_number === 'reinheimer.tyrescan.ts005')
           && <ReportDach report={this.state.report}></ReportDach>}
          {/* {model_number === 'honda.philippine.ts005' && <ReportHonda report={this.state.report}></ReportHonda>} */}

          {(this.state.report && generalModel) && (
            <div>
              {/* 顶部信息 */}
              <div className="report-item">
                {(model_number == 'acura.tyrescan.ts004' || model_number == 'acura.tyrescan.ts005') && this.returnOugeHeader()}
                {model_number !== 'acura.tyrescan.ts004' && model_number !== 'acura.tyrescan.ts005' && (<div className="report-item-head">
                  <div style={{ marginBottom: 8 }}>
                    <img
                      src={logo ? this.getLogo(logo) : require('../../assets/logo.png')}
                      alt=""
                      style={{ width: 190, height: 51, objectFit: "fill" }}
                    />
                    <div style={{ fontSize: 12 }}>
                      <span>{intl.get('txt_fwmd')}：</span>
                      <span>{store.name}</span>
                    </div>
                    <div>
                      <span>{intl.get('txt_mddz')}：</span>
                      {/* <span>{`${store.province}${store.city}${store.address}`}</span> */}
                      <span>{`${store_address}`}</span>
                    </div>
                  </div>
                  {!this.state.cormach&& (<div
                    style={{
                      display: 'flex',
                      alignItems: "center",
                      flexDirection: 'column'
                    }}

                  >
                    <QRCode
                      value={this.props.store.rootUrl + `report/${uuid}/?lang=` + intl.options.currentLocale}
                      size={68}
                    />

                    <div style={{ whiteSpace: 'pre-wrap', textAlign: "center", lineHeight: 1 }}>{intl.get('txt_sewmts')} </div>
                    <div style={{ whiteSpace: 'pre-wrap', textAlign: "center", lineHeight: 1,marginTop:5 }} className="noprint">
                      <a href="" onClick={()=>window.print()}>{intl.get('txt_print')}</a>
                    </div>
                  </div>)}
                </div>)}
                {model_number != 'ip.tyrescan.ts004' && (<div
                  className="report-head-info"
                  style={{ paddingLeft: 10, paddingRight: 10 }}
                >
                  <div style={{ width: "60%" }}>
                    <div className="report-head-info__item">
                      <div> <span className="tit small">{intl.get('txt_cphm')}</span></div>
                      <div> <span className="cnt">{plate_no.toUpperCase()}</span></div>
                    </div>
                    <div className="report-head-info__item">
                      <div><span className="tit">{intl.get('txt_jcsj')}</span></div>
                      <div> <span className="cnt">
                        {" "}
                        {this.getTimeShow(device_time)}
                      </span></div>
                    </div>
                    {(model_number != 'michelin.tyrescan.ts004') && <div className="report-head-info__item">
                      <div> <span className="tit">{intl.get('txt_jcsb')}</span></div>
                      <div> <span className="cnt">{device_number}</span></div>
                    </div>}
                    {(model_number == 'tyrehub.tyrescan.ts004' || (model_number == 'tyrehub.tyrescan.ts005') || model_number == 'michelin.tyrescan.ts004') && <div className="report-head-info__item">
                      <div> <span className="tit">{intl.get('txt_jishimz')}</span></div>
                      <div>  <span className="cnt">{inspector ? inspector : "-"}</span></div>
                    </div>}
                    <div className="report-head-info__item">
                      <div> <span className="tit">{intl.get('txt_ddmd')}</span></div>
                      <div> <span className="cnt">{purpose ? this.getpurposeStr(purpose) : '-'}</span></div>
                    </div>
                  </div>
                  <div style={{ width: "40%" }}>
                    {(model_number == 'tyrehub.tyrescan.ts004' || (model_number == 'tyrehub.tyrescan.ts005') || model_number == 'michelin.tyrescan.ts004') && <div className="report-head-info__item">
                      <div> <span className="tit">{intl.get('txt_contactway')}</span></div>
                      <div> <span className="cnt">{mobile ? mobile : '-'}</span></div>
                    </div>}
                    <div className="report-head-info__item">
                      <div> <span className="tit">{intl.get('txt_chex')}</span></div>
                      <div> <span className="cnt">{car ? car : "-"}</span></div>
                    </div>
                    <div className="report-head-info__item">
                      <div> <span className="tit">{intl.get('txt_lic')}</span></div>
                      <div>  <span className="cnt">
                        {odometer ? odometer +" " : " "}{mileageUnit}</span>  </div>
                    </div>
                    {(model_number != 'tyrehub.tyrescan.ts004' && (model_number != 'tyrehub.tyrescan.ts005') && model_number != 'michelin.tyrescan.ts004') && <div className="report-head-info__item">
                      <div> <span className="tit">{intl.get('txt_jishimz')}</span></div>
                      <div> <span className="cnt">{inspector ? inspector : "-"}</span></div>
                    </div>}
                    <div className="report-head-info__item">
                      <div> <span className="tit">{intl.get('txt_beiz')}</span></div>
                      <div>  <span className="cnt">{remark ? remark : "-"}</span></div>
                    </div>
                  </div>
                </div>)}
                {model_number == 'ip.tyrescan.ts004' && (this.getipHeader())}
              </div>
              {/* 检测建议 */}
              <div className="report-item section-2">
                <div className="report-item-head">
                  <h2 className="tit">{intl.get('txt_jcjyi')}</h2>
                </div>
                <div className="report-item-main">
                  {suggestion.map((item, index) => (
                    this.returnDescribe(suggestion, item.describe, item, index, model_number)
                  ))}
                </div>
              </div>
               {/* 四轮定位标识 */}
               {(need_wheel_align === true && autogem &&
              <div className="report-item section-3">
                <div className="report-item-head">
                  <h2 className="tit">
                    Wheel Alignment
                  </h2>                  
                </div>
                <div className="report-item-main" style={{top:20,}}>
                  <img 
                  style={{
                    position: "relative",
                    width: 30,
                    height: 30,
                    objectFit: "contain",
                    // zIndex: 10,
                    left:20,
                  }}
                  src={require("../../assets/report/wheelalign.jpg")} alt="" /> 
                  <span style={{paddingLeft:30,}}>{intl.get('txt_wheelalignment')}</span>        
                </div>                 
              </div>)}

              {/* Vechile Inspections */}
              {inspections && inspections.washing_liquid && inspections.radiator_fluid && (<div className="report-item" >
                        {this.returnNote()}
                        <div className="report-item-head">
                            <h2 className="tit">{intl.get('txt_hood')}</h2>

                            <div
                                style={{ paddingLeft: 20, paddingRight: 20, paddingLeft: 20, paddingRight: 20, paddingTop: 3, paddingBottom: 3 }}
                                onClick={() => {
                                    this.setState({ showMotor: !this.state.showMotor })
                                }}><img src={require('../../assets/image/gray_icon.png')} style={{ width: 11, height: 6 }}></img></div>
                        </div>
                        {this.state.showMotor && (<div>
                            {this.returnSingle(intl.get('txt_wash_liquid'), intl.get('txt_level_control'), inspections.washing_liquid)}
                            {this.returnSingle(intl.get('txt_radiator_fluid'), intl.get('txt_level_control'), inspections.radiator_fluid)}
                            {this.returnSingle(intl.get('txt_engine_oil'), intl.get('txt_level_control'), inspections.engine_oil)}
                            {this.returnSingle(intl.get('txt_brake_fluid'), intl.get('txt_zhiliangkongzhi'), inspections.brake_fluid)}
                            {this.returnSingle(intl.get('txt_batteria'), intl.get('txt_multimeter'), inspections.battery)}
                        </div>)}
                        <div className="report-item-head" style={{ marginTop: 10 }}>
                            <h2 className="tit">{intl.get('txt_change_control')}</h2>

                            <div
                                style={{ paddingLeft: 20, paddingRight: 20, paddingLeft: 20, paddingRight: 20, paddingTop: 3, paddingBottom: 3 }}
                                onClick={() => {
                                    this.setState({ showControl: !this.state.showControl })
                                }}><img src={require('../../assets/image/gray_icon.png')} style={{ width: 11, height: 6 }}></img></div>
                        </div>
                        {this.state.showControl && (<div>
                            {this.returnSingle(intl.get('txt_air_control'), intl.get('txt_last_reload'), inspections.conditioning_system, 1)}
                            {this.returnSingle(intl.get('txt_lighting'), intl.get('txt_verification'), inspections.lighting)}
                            {this.returnSingle(intl.get('txt_verification1'), intl.get('txt_wear_condition'), inspections.wiper)}
                            {this.returnSingle(intl.get('txt_quality_control'), intl.get('txt_dynamometer'), inspections.quality_control, 2)}
                        </div>)}
                        <div className="report-item-head" style={{ marginTop: 10 }}>
                            <h2 className="tit">{intl.get('txt_subtotal')}</h2>

                            <div
                                style={{ paddingLeft: 20, paddingRight: 20, paddingTop: 3, paddingBottom: 3 }}
                                onClick={() => {
                                    this.setState({ showSum: !this.state.showSum })
                                }}><img src={require('../../assets/image/gray_icon.png')} style={{ width: 11, height: 6 }}></img></div>
                        </div>
                        {this.state.showSum && (<div>
                            {this.returnSingle(intl.get('txt_shock_absorber'), intl.get('txt_check_loss'), inspections.shock_absorber)}
                            {this.returnSingle(intl.get('txt_brake_disc'), intl.get('txt_wear_condition'), inspections.brake_disc)}
                            {this.returnSingle(intl.get('txt_brake_pads'), intl.get('txt_wear_condition'), inspections.brake_pads)}
                        </div>)}
                    </div>
                    )}

              {/* 颜色标识 */}
              { /**
              *   <div className="report-item section-3">
                <div className="report-item-head">
                  <h2 className="tit">
                    {intl.get('txt_ysbs')}
                    <img src={intl.options.currentLocale == 'zh' ? require("../../assets/report/tip.png") : require("../../assets/report/entip.png")} alt="" />
                  </h2>
                </div>
              </div>
              */}

              {/* 整体磨损 */}
              <div className="report-item-ztms section-4">
                <div className="report-item-headnam">
                  <h2 className="tit">{intl.get('txt_wear_overall')}</h2>
                  {tyreunit == 'unit_in' && (<div>{'(' + intl.get('txt_namtishi') + ')'}</div>)}
                </div>

                {this.getRemindView(wear_threshold, tyreunit)}

                <div className="report-item-main">
                  <div style={{ position: "relative" , marginTop:40,}}>
                    <img
                      style={{
                        position: "relative",
                        width: 80,
                        height: 280,
                        objectFit: "contain",
                        zIndex: 10
                      }}
                      src={require("../../assets/report/reportcar1.png")}
                      alt=""
                    />
                    <TyreColor
                      status={{
                        lf: {
                          color: wear_lf_degree
                        },
                        rf: {
                          color: wear_rf_degree
                        },
                        lb: {
                          color: wear_lb_degree
                        },
                        rb: {
                          color: wear_rb_degree
                        }
                      }}
                    />
                  </div>

                  <Tyre
                    wear_threshold={wear_threshold}
                    tyreunit={tyreunit}
                    model={model_number}
                    data={{
                      lf: {
                        data: wear_lf_data ? wear_lf_data.split(",") : null,
                        color: wear_lf_degree,
                        info: tyre_lf,
                        last: last_wear && last_wear.last_lf_degree ? last_wear.last_lf_degree : '',
                        season: season && season.LF ? season.LF : '',
                        goodsname: goodsname && goodsname.LF ? goodsname.LF : '',
                        tireremark: tireremark && tireremark.LF ? tireremark.LF : '',
                        bolt: bolt && bolt.LF ? bolt.LF : '',
                      },
                      rf: {
                        data: wear_rf_data ? wear_rf_data.split(",") : null,
                        color: wear_rf_degree,
                        info: tyre_rf,
                        last: last_wear && last_wear.last_rf_degree ? last_wear.last_rf_degree : '',
                        season: season && season.RF ? season.RF : '',
                        goodsname: goodsname && goodsname.RF ? goodsname.RF : '',
                        tireremark: tireremark && tireremark.RF ? tireremark.RF : '',
                        bolt: bolt && bolt.RF ? bolt.RF : '',
                      },
                      lb: {
                        data: wear_lb_data ? wear_lb_data.split(",") : null,
                        color: wear_lb_degree,
                        info: tyre_lb,
                        last: last_wear && last_wear.last_lb_degree ? last_wear.last_lb_degree : '',
                        season: season && season.LB ? season.LB : '',
                        goodsname: goodsname && goodsname.LB ? goodsname.LB : '',
                        tireremark: tireremark && tireremark.LB ? tireremark.LB : '',
                        bolt: bolt && bolt.LB ? bolt.LB : '',
                      },
                      rb: {
                        data: wear_rb_data ? wear_rb_data.split(",") : null,
                        color: wear_rb_degree,
                        info: tyre_rb,
                        last: last_wear && last_wear.last_rb_degree ? last_wear.last_rb_degree : '',
                        season: season && season.RB ? season.RB : '',
                        goodsname: goodsname && goodsname.RB ? goodsname.RB : '',
                        tireremark: tireremark && tireremark.RB ? tireremark.RB : '',
                        bolt: bolt && bolt.RB ? bolt.RB : '',
                      }
                    }}
                  />
                </div>
              </div>
              {/* 异常磨损 */}
              <div className="report-item">
                <div className="report-item-head">
                  <h2 className="tit">{intl.get('txt_pattern_wear')}</h2>
                </div>

                {/* <img alt ="" style={{ paddingRight: '10px', paddingLeft: '10px', height: '28px', marginTop: '4px' }} src={lang.includes("zh") ? require("../../assets/report/reportycms.png") :
                  lang === 'it' ? require("../../assets/report/ycmsydl.png") : lang.includes("en")? require("../../assets/report/ycmsen.png")
                    : lang === 'fr' ? require("../../assets/report/ycmsfy.png") : lang === 'ms' ? require("../../assets/report/ycmsml.png") : lang === 'de' ? require("../../assets/report/ycmsdy.png") : lang === 'ja' ? require('../../assets/report/ycmsja.png') :
                      lang === 'pl' ? require('../../assets/report/ycmspl.png') :  require("../../assets/report/ycmsen.png")}></img> */}
                
                {this.getRemindBar()}

                <div className="report-item-main" style={{ paddingBottom: lang.includes("zh") ? 40 : 60 }}>
                  <Frame
                    data={{
                      lf: { data: ecc_wear_lf_degree, trauma: tyre_lf },
                      rf: { data: ecc_wear_rf_degree, trauma: tyre_rf },
                      lb: { data: ecc_wear_lb_degree, trauma: tyre_lb },
                      rb: { data: ecc_wear_rb_degree, trauma: tyre_rb }
                    }}
                    suggestion={suggestion}
                    conclusion={conclusion}
                    transposition={transposition}
                  />
                </div>
              </div>


              {/* 轮胎外观 */}
              <div className="report-item section-4">
                <div className="report-item-head">
                  <h2 className="tit">{intl.get('txt_ltws')}</h2>
                </div>
                <InstallView data={{ lf: tyre_lf, lb: tyre_lb, rf: tyre_rf, rb: tyre_rb }}>
                </InstallView >
                <div className="report-item-main">
                  <div style={{ position: "relative" }}>
                    <img
                      style={{
                        position: "relative",
                        width: 80,
                        height: 280,
                        objectFit: "contain",
                        zIndex: 10
                      }}
                      src={require("../../assets/report/reportcar1.png")}
                      alt=""
                    />
                    <TyreColor1
                      status={{
                        lf: {
                          color: tyre_lf
                        },
                        rf: {
                          color: tyre_rf
                        },
                        lb: {
                          color: tyre_lb
                        },
                        rb: {
                          color: tyre_rb
                        }
                      }}
                    />
                  </div>

                  <Tyre_ltwg
                    data={{
                      lf: {

                        img: trauma_lf_img,
                        info: tyre_lf
                      },
                      rf: {

                        img: trauma_rf_img,
                        info: tyre_rf
                      },
                      lb: {
                        img: trauma_lb_img,
                        info: tyre_lb
                      },
                      rb: {
                        img: trauma_rb_img,
                        info: tyre_rb
                      }
                    }}
                  />
                </div>
              </div>

              {/* 轮胎续航里程估算 */}
              <div className="report-item section-4">
                <div className="report-item-head">
                  <h2 className="tit">{intl.get('txt_ltxhlcgs')}</h2>
                </div>

                <div className="report-item-main" style={lang.includes("zh") ? {} : { paddingBottom: 60 }}>
                  <div style={{ position: "relative" }}>
                    <img
                      style={{
                        position: "relative",
                        width: 80,
                        height: 280,
                        objectFit: "contain",
                        zIndex: 10
                      }}
                      src={require("../../assets/report/reportcar1.png")}
                      alt=""
                    />

                  </div>

                  <Tyre_cllc
                    unit={tyreunit}
                    wear_threshold={wear_threshold}
                    model={model_number}
                    mileageUnit={mileageUnit}
                    time={create_time}
                    data={{
                      lf: {
                        info: tyre_lf,
                        value: wear_lf_value,
                        season: season && season.LF ? season.LF : ''
                      },
                      rf: {
                        info: tyre_rf,
                        value: wear_rf_value,
                        season: season && season.RF ? season.RF : ''
                      },
                      lb: {
                        info: tyre_lb,
                        value: wear_lb_value,
                        season: season && season.LB ? season.LB : ''
                      },
                      rb: {
                        info: tyre_rb,
                        value: wear_rb_value,
                        season: season && season.RB ? season.RB : ''
                      }
                    }}
                  />
                </div>
              </div>


              {/* TODO:dot估算 */}
              {/* <div className="report-item section-4">
                <div className="report-item-head" >
                  <h2 className="tit">{intl.get('txt_dottx')}</h2>

                </div>
                <p style={{ marginLeft: 20 }}>{intl.get('txt_dotsjztx')}</p>
                <div className="report-item-main" style={{ paddingBottom: lang == 'zh' ? '40px' : '100px' }}>
                  <div style={{ position: "relative" }}>
                    <img
                      style={{
                        position: "relative",
                        width: 80,
                        height: 280,
                        objectFit: "contain",
                        zIndex: 10
                      }}
                      src={require("../../assets/report/reportcar1.png")}
                      alt=""
                    />
                  </div>

                  <Tyre_dot
                    model={model_number}
                    time={create_time}
                    data={{
                      lf: {
                        info: tyre_lf,
                        wear: wear_lf_value,
                        season: season && season.LF ? season.LF : ''
                      },
                      rf: {
                        info: tyre_rf,
                        wear: wear_rf_value,
                        season: season && season.RF ? season.RF : ''
                      },
                      lb: {
                        info: tyre_lb,
                        wear: wear_lb_value,
                        season: season && season.LB ? season.LB : ''
                      },
                      rb: {
                        info: tyre_rb,
                        wear: wear_rb_value,
                        season: season && season.RB ? season.RB : ''
                      }
                    }}
                  />
                </div>
              </div> */}

              {/* TODO:刹车距离 */}
              <div className="report-item">
                <div className="report-item-head">
                  <h2 className="tit">{intl.get('txt_dqscjltx')}</h2>
                </div>
                <div className="report-item-main">
                  <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                    <BrakeBar level={brake_type} />
                    {/* TODO:添加提醒 */}
                  </div>
                </div>
                <div style={{ paddingLeft: 10, paddingRight: 10 }}>
                  <p style={{ fontSize: 14 }}>{this.returnsctixing(brake_type)}</p>
                </div>

              </div>

              {/* TODO:里程估算 
              <div className="report-item">
                <div className="report-item-head">
                  <h2 className="tit">{intl.get('txt_ltxhlcgs')}</h2>
                </div>
                  <span style={{fontSize:'14px' ,marginTop:'1px',marginLeft:'20px'}}>{intl.get('txt_danweikm')}</span>
                <div className="report-item-main">
                  <div style={{ paddingTop: 20, paddingBottom: 20 }}>
                    <BrakeBarLCGS level={brake_type} />
                  
                  </div>
                </div>
                <div style={{ paddingLeft: 20,paddingRight:20 }}>
                  <p style={{ fontSize: 14 }}>{intl.get('txt_bgtixing') +this.returnslcgstx(brake_type)}</p>
                </div>

              </div>*/}

              {model_number !== 'acura.tyrescan.ts004' && model_number !== 'acura.tyrescan.ts005' && model_number !== 'ip.tyrescan.ts004' && (<div>
                <img style={{ width: "100%", height: 100 }}
                  resizemode="contain"
                  src={(model_number == 'acura.tyrescan.ts004' || model_number == 'acura.tyrescan.ts005') ? require('../../assets/report/ougelogo.png') : intl.options.currentLocale == 'zh' ? require("../../assets/report/guanggao.png") : require("../../assets/report/guanggaoen.png")} ></img>

              </div>)}


              {(model_number == 'acura.tyrescan.ts004' || model_number == 'acura.tyrescan.ts005') && (<div> <img style={{ width: 264, height: 30 }}
                resizemode="contain"
                src={require('../../assets/report/ougelogo.png')}></img>
              </div>)}

            </div>
          )}

        </div>
      );
    }
  }

  getRemindView(data, tyreunit) {
    let low = data.low / 10;
    let high = data.high / 10;
    let danwei = 'mm'
    if (tyreunit && tyreunit == 'unit_in') {
      low = (low * 1.25984).toFixed(1)
      high = (high * 1.25984).toFixed(1)
      danwei = '/32in'
    }
    return (
      <div className="report-ztms1">
        <img style={{ height: '32px', marginTop: '4px' }} src={require('../../assets/image/bgt.png')}></img>

        {data && (<div style={{
          display: "flex", flexDirection: 'row', alignItems: 'center'
          , height: '32px', justifyContent: 'space-between', position: 'absolute', top: '4px', left: 10, right: 10,
          paddingLeft: 10, paddingRight: 10
        }}>
          <div style={{ lineHeight: 1, textAlign: 'center', color: "white", }}>
            <div>{intl.get('txt_replace')}</div>
            <div>{'<' + low + danwei}</div>
          </div>
          <div style={{ lineHeight: 1, textAlign: 'center', color: "white" }}>
            <div>{intl.get('txt_Border')}</div>
            <div>{low + danwei + '-' + high + danwei}</div>
          </div>
          <div style={{ lineHeight: 1, textAlign: 'center', color: "white" }}>
            <div>{intl.get('txt_GoodState')}</div>
            <div>{'≥' + high + danwei}</div>
          </div>
        </div>)}
      </div>
    )
  }

  getRemindBar() {
    
    return (
      <div className="report-ztms1">
        <img style={{ height: '32px', marginTop: '4px' }} src={require('../../assets/image/bgt.png')}></img>

        <div style={{
          display: "flex", flexDirection: 'row', alignItems: 'center'
          , height: '32px', justifyContent: 'space-between', position: 'absolute', top: '4px', left: 10, right: 10,
          paddingLeft: 10, paddingRight: 10
        }}>
          <div style={{ lineHeight: 1, textAlign: 'center', color: "white", }}>
            <div>{intl.get('txt_GraveWear')}</div>
          </div>
          <div style={{ lineHeight: 1, textAlign: 'center', color: "white" }}>
            <div>{intl.get('txt_LightWear')}</div>
          </div>
          <div style={{ lineHeight: 1, textAlign: 'center', color: "white" }}>
            <div>{intl.get('txt_GoodState')}</div>
          </div>
        </div>
      </div>
    )
  }


  getipHeader() {
    if (this.state.report) {
      var {
        car,
        plate_no,
        device_time,
        odometer,
        purpose,
        remark,
        inspector,//技师名字
        tyreunit,
        mobile,
        customer,
        email
      } = this.state.report;
    }
    return (
      <div
        className="report-head-info"
        style={{ paddingLeft: 10, paddingRight: 10 }}
      >
        <div style={{ width: "60%" }}>
          <div className="report-head-info__item">
            <div> <span className="tit small">{intl.get('txt_cphm')}</span></div>
            <div> <span className="cnt">{plate_no.toUpperCase()}</span></div>
          </div>
          <div className="report-head-info__item">
            <div><span className="tit">{intl.get('txt_jcsj')}</span></div>
            <div> <span className="cnt">
              {" "}
              {this.getTimeShow(device_time)}
            </span></div>
          </div>
          <div className="report-head-info__item">
            <div> <span className="tit">{intl.get('txt_contactway')}</span></div>
            <div> <span className="cnt">{mobile ? mobile : '-'}</span></div>
          </div>
          <div className="report-head-info__item">
            <div> <span className="tit">{intl.get('txt_ddmd')}</span></div>
            <div> <span className="cnt">{purpose ? this.getpurposeStr(purpose) : '-'}</span></div>
          </div>

          <div className="report-head-info__item">
            <div> <span className="tit">{intl.get('txt_khxm')}</span></div>
            <div> <span className="cnt">{customer ? customer : '-'}</span></div>
          </div>
        </div>
        <div style={{ width: "40%" }}>
          <div className="report-head-info__item">
            <div> <span className="tit">{intl.get('txt_chex')}</span></div>
            <div> <span className="cnt">{car ? car : "-"}</span></div>
          </div>
          <div className="report-head-info__item">
            <div> <span className="tit">{intl.get('txt_lic')}</span></div>
            <div>  <span className="cnt">
              {odometer ? odometer : "0"}
            </span> <span>{tyreunit == 'unit_in' ? 'miles' : 'KM'}</span>  </div>
          </div>
          <div className="report-head-info__item">
            <div> <span className="tit">{intl.get('txt_jishimz')}</span></div>
            <div>  <span className="cnt">{inspector ? inspector : "-"}</span></div>
          </div>
          <div className="report-head-info__item">
            <div> <span className="tit">{intl.get('txt_khyx')}</span></div>
            <div>  <span className="cnt">{email ? email : "-"}</span></div>
          </div>
          <div className="report-head-info__item">
            <div> <span className="tit">{intl.get('txt_beiz')}</span></div>
            <div>  <span className="cnt">{remark ? remark : "-"}</span></div>
          </div>
        </div>
      </div>
    )

  }

  returnNote() {
    return (
        <div style={{ paddingLeft: 18, paddingRight: 18, marginBottom: 10 }}>
            {this.noteArr.map((item, index) => {
                return (
                    <div style={{ display: "flex", flexDirection: 'row', alignItems: 'center', }} key={index}>
                        <div style={{ marginRight: 5, width: 12, height: 12, background: item.color, borderRadius: 12 }}></div>
                        <div>{item.name}</div>
                    </div>
                )
            })}
        </div>
    )
}

  getTimeShow(device_time) {
    let lang = intl.options.currentLocale
    if (lang !== 'zh') {
      let temptime = device_time.replace("T", " ")
      let timeArr = temptime.split(' ')

      let time1 = timeArr[0].split('-')


      return time1[2] + '/' + time1[1] + '/' + time1[0] + ' ' + timeArr[1]
    } else {

      return device_time.replace("T", " ")
    }

  }


  returnOugeHeader() {
    if (this.state.report) {
      var {
        store,
        model_number,  
        uuid,
      } = this.state.report;
      
    }

    return (
      <div className="report-item-headouge">

        { !this.state.cormach && (<div
          style={{
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <QRCode
            value={this.props.store.rootUrl + `report/${uuid}/?lang=` + intl.options.currentLocale}
            size={68}
          />

          <div style={{ whiteSpace: 'pre-wrap', textAlign: "center", lineHeight: 1, width: 68 }}>{intl.get('txt_sewmts')} </div>
          {/* <div style={{ whiteSpace: 'pre-wrap', textAlign: "center", lineHeight: 1,marginTop:5 }} className="noprint">
                    <a href="" onClick={()=>window.print()}>{intl.get('txt_print')}</a></div> */}

          <div style={{ fontSize: 12 }}>
            <span>{intl.get('txt_fwmd')}：</span>
            <span>{store.name}</span>
          </div>
          <div>
            <span>{intl.get('txt_mddz')}：</span>
            <span>{`${store.province}${store.city}${store.address}`}</span>
          </div>

        </div>)}

        <div style={{ marginBottom: 8,display: 'flex',flexDirection: 'column' }}>
          <div>
          <img
            src={require('../../assets/report/ougexiaologo.png')}
            alt=""
            style={{ width: 113, height: 85, objectFit: "fill" }}
          /></div>
          <div style={{ whiteSpace: 'pre-wrap', textAlign: "center", lineHeight: 1,marginTop:5 }} className="noprint">
           <a href="" onClick={()=>window.print()}>{intl.get('txt_print')}</a>
           </div>
        </div>
       

      </div>
    )
  }

  getQueryString(name) {
    let reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    let r = window.location.search.substr(1).match(reg);
    if (r != null) return decodeURI(r[2]); return null;
  }

  getLogo(originalUrl){
     const httpUrl = originalUrl.replace(/^https/, 'http');
     return httpUrl
  }

  taiwanUi() {
    if (this.state.report) {
      var {
        brake_type,
        car,
        plate_no,
        device_time,
        odometer,
        store_address,
        store,
        model_name,
        conclusion,
        suggestion,
        wear_lf_degree,
        wear_rf_degree,
        wear_lb_degree,
        wear_rb_degree,
        ecc_wear_lf_degree,
        ecc_wear_rf_degree,
        ecc_wear_lb_degree,
        ecc_wear_rb_degree,
        transposition,
        wear_threshold,
        wear_lf_data,
        wear_rf_data,
        wear_lb_data,
        wear_rb_data,
        wear_coordinate_max,
        purpose,
        remark,
        tyre_lb,
        tyre_lf,
        tyre_rb,
        tyre_rf,
        uuid,
        trauma_lf_img,
        trauma_rf_img,
        trauma_lb_img,
        trauma_rb_img,
        language,
        last_wear,
        inspector,//技师名字
        inspector_number,
        wear_lf_value,
        wear_lb_value,
        wear_rf_value,
        wear_rb_value,
        logo,
        model_number, 
        create_time,
      } = this.state.report;
    }
    let purposeStr = purpose ? this.getpurposeStr(purpose) : '-'
    let lang = intl.options.currentLocale

    return (
      <div>
        {/* 顶部信息 */}
        <div className="report-item">
          <div className="report-item-head">
            <div style={{ marginBottom: 8 }}>
              <img
                src={logo ? logo : require('../../assets/logo.png')}
                alt=""
                style={{ width: 190, height: 51, objectFit: "fill" }}
              />
              <div style={{ fontSize: 12 }}>
                <span>{intl.get('txt_fwmd')}：</span>
                <span>{store.name}</span>
              </div>
              <div>
                <span>{intl.get('txt_mddz')}：</span>
                {/* <span>{`${store.province}${store.city}${store.address}`}</span> */}
                <span>{`${store_address}`}</span>
              </div>
            </div>

          </div>
          <div
            className="report-head-info"
            style={{ paddingLeft: 10, paddingRight: 10 }}
          >
            <div style={{ width: "60%" }}>
              <div className="report-head-info__item">
                <div> <span className="tit small">{intl.get('txt_cphm')}</span></div>
                <div> <span className="cnt">{plate_no.toUpperCase()}</span></div>
              </div>
              <div className="report-head-info__item">
                <div><span className="tit">{intl.get('txt_jcsj')}</span></div>
                <div> <span className="cnt">
                  {" "}
                  {this.getTimeShow(device_time)}
                </span></div>
              </div>
              <div className="report-head-info__item">
                <div> <span className="tit">{intl.get('txt_beiz')}</span></div>
                <div>  <span className="cnt">{remark ? remark : "-"}</span></div>
              </div>
            </div>
            <div style={{ width: "40%" }}>
              <div className="report-head-info__item">
                <div> <span className="tit">{intl.get('txt_chex')}</span></div>
                <div> <span className="cnt">{car ? car : "-"}</span></div>
              </div>

              <div className="report-head-info__item">
                <div> <span className="tit">{intl.get('txt_ganbu')}</span></div>
                <div>  <span className="cnt">{inspector ? inspector : "-"}</span></div>
              </div>

            </div>
          </div>
        </div>
        {/* 检测建议 */}
        <div className="report-item section-2">
          <div className="report-item-head">
            <h2 className="tit">{intl.get('txt_jcjyi')}</h2>
          </div>
          <div className="report-item-main">
            {suggestion.map((item, index) => {

              if (index == 0) {
                return (
                  this.returnDescribe(suggestion, item.describe, item, index, model_number))
              }
            }
            )}
          </div>
        </div>
        {/* 颜色标识 */}
        { /**
    *   <div className="report-item section-3">
      <div className="report-item-head">
        <h2 className="tit">
          {intl.get('txt_ysbs')}
          <img src={intl.options.currentLocale == 'zh' ? require("../../assets/report/tip.png") : require("../../assets/report/entip.png")} alt="" />
        </h2>
      </div>
    </div>
     */}

        {/* 整体磨损 */}
        <div className="report-item-ztmstw section-4">
          <div className="report-item-head">
            <h2 className="tit">{intl.get('txt_ztms')}</h2>
          </div>
          <div className="report-ztms1">

            <img style={{ height: '28px', marginTop: '4px' }} src={require("../../assets/report/tiptw.png")}></img>
          </div>
          <div className="report-item-main">
            <div style={{ position: "relative" }}>
              <img
                style={{
                  position: "relative",
                  width: 80,
                  height: 280,
                  objectFit: "contain",
                  zIndex: 10
                }}
                src={require("../../assets/report/reportcar1.png")}
                alt=""
              />
              <TyreColor
                status={{
                  lf: {
                    color: wear_lf_degree
                  },
                  rf: {
                    color: wear_rf_degree
                  },
                  lb: {
                    color: wear_lb_degree
                  },
                  rb: {
                    color: wear_rb_degree
                  }
                }}
              />
            </div>

            <Tyre_TW
              data={{
                lf: {
                  data: wear_lf_data ? wear_lf_data.split(",") : null,
                  color: wear_lf_degree,
                  info: tyre_lf,
                  last: last_wear && last_wear.last_lf_degree ? last_wear.last_lf_degree : ''
                },
                rf: {
                  data: wear_rf_data ? wear_rf_data.split(",") : null,
                  color: wear_rf_degree,
                  info: tyre_rf,
                  last: last_wear && last_wear.last_rf_degree ? last_wear.last_rf_degree : ''
                },
                lb: {
                  data: wear_lb_data ? wear_lb_data.split(",") : null,
                  color: wear_lb_degree,
                  info: tyre_lb,
                  last: last_wear && last_wear.last_lb_degree ? last_wear.last_lb_degree : ''
                },
                rb: {
                  data: wear_rb_data ? wear_rb_data.split(",") : null,
                  color: wear_rb_degree,
                  info: tyre_rb,
                  last: last_wear && last_wear.last_rb_degree ? last_wear.last_rb_degree : ''
                }
              }}
            />
          </div>
        </div>
      </div>)
  }

  returnslcgstx(brake_type) {
    if (this.state.report) {

      let arr = [80000, 73600, 62400, 49600, 36800, 24000, 11200, 1600, 0, 0];

      let data = arr[brake_type - 1]
      let str1
      if (data > 0) {

        str1 = intl.get('txt_ltlcgstm');
        str1 = str1.replace(new RegExp("\\{" + 0 + "\\}", "g"), data)
      } else {
        str1 = intl.get('txt_dqltlctx')
      }


      return str1;
    }

  }

  wxconfig(report) {
    let url = window.location.href;
    let appId = global.constants.wxappid;

    let temptime = report.device_time.replace("T", " ")
    let imageresouce = require('../../assets/icon-60@3x.png')
    //let imageresouce = require('../../assets/image/ic_launcher.png')
    Apiwx.getsha1code({ params: { url: url } }).then(res => {
      if (res.data.code == 0) {

        let data = res.data.data
        let nonceStr = data.nonceStr
        let signature = data.signature
        let time = data.timestamp
        window.wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: appId, // 必填，公众号的唯一标识
          timestamp: time, // 必填，生成签名的时间戳
          nonceStr: nonceStr, // 必填，生成签名的随机串
          signature: signature,// 必填，签名
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
        });
        window.wx.ready(() => {
          console.log('ready success')
          // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
          window.wx.updateAppMessageShareData({
            title: report.plate_no, // 分享标题
            desc: temptime + '生成的检测报告', // 分享描述
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: report.logo, // 分享图标
            success: () => {
              // 设置成功
              console.log('updateAppMessageShareData success')
            }
          })



          window.wx.updateTimelineShareData({
            title: report.plate_no, // 分享标题
            link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
            imgUrl: report.logo, // 分享图标
            success: () => {
              // 设置成功
              console.log('updateTimelineShareData success')
            }
          })


        });

      }
    })

  }
  returnSingle(text1, text2, level, type = 0) {


    if (type == 0) {
        return (
            <div style={{ paddingLeft: 18, paddingRight: 18, marginTop: 10 }}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ lineHeight: 1.5 }}>
                        <div style={{ fontSize: 14, color: 'black' }}>{text1}</div>
                        <div>{text2}</div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 60, width: 100 }}>
                        <div style={{ width: 14, height: 14, background: level == 'high' ? this.noteArr[2].color : level == 'middle' ? this.noteArr[1].color : this.noteArr[0].color, borderRadius: 16 }}></div>
                        <div>{this.getleverstr(level)}</div>
                    </div>
                </div>
                <div style={{ width: '100%', height: 1, background: '#cbcbcb', marginTop: 10 }}></div>
            </div>
        )
    } else if (type == 1) {
        let temparr = level.split('/')
        return (
            <div style={{ paddingLeft: 18, paddingRight: 18, marginTop: 10 }}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ lineHeight: 1.5 }}>
                        <div style={{ fontSize: 14, color: 'black' }}>{text1}</div>
                        <div>{text2}</div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 60, width: 100 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', fontSize: 14 }}>
                            <span style={{ textDecoration: 'underline', paddingRight: 2, paddingLeft: 2 }}>{temparr[0]}</span>
                            <span>{'/'}</span>
                            <span style={{ textDecoration: 'underline', paddingRight: 2, paddingLeft: 2 }}>{temparr[1]}</span>
                            <span>{'/'}</span>
                            <span style={{ textDecoration: 'underline', paddingRight: 2, paddingLeft: 2 }}>{temparr[2]}</span>
                        </div>
                    </div>
                </div>
                <div style={{ width: '100%', height: 1, background: '#cbcbcb', marginTop: 10 }}></div>
            </div>
        )
    } else if (type == 2) {
        return (
            <div style={{ paddingLeft: 18, paddingRight: 18, marginTop: 10 }}>
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div style={{ lineHeight: 1.5 }}>
                        <div style={{ fontSize: 14, color: 'black' }}>{text1}</div>
                        <div>{text2}</div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: 60, width: 100 }}>

                        <div>{level}</div>
                    </div>
                </div>
                <div style={{ width: '100%', height: 1, background: '#cbcbcb', marginTop: 10 }}></div>
            </div>
        )
    }


}


getleverstr(level) {
    let str = ''
    if (level == 'high') {
        str = intl.get('txt_levelhigh')
    }
    else if (level == 'middle') {
        str = intl.get('txt_levelmiddle')
    } else {
        str = intl.get('txt_levellow')
    }
    return str
}

  returnsctixing(data) {
    let str = intl.get('txt_bgtixing')
    let str1 = intl.get('txt_bgtuxubfnr')
    let num = 14;

    switch (data) {
      case 1:
        num = 0;
        break;
      case 2:
        num = 3
        break;
      case 3:
        num = 6
        break;
      case 4:
        num = 10
        break;
      case 5:
        num = 14
        break;
      case 6:
        num = 20
        break;
      case 7:
        num = 27
        break
      case 8:
        num = 39
        break
      case 9:
        num = 55
        break
      case 10:
        num = 87
        break

    }
    str1 = str1.replace(new RegExp("\\{" + 0 + "\\}", "g"), num)
    return str + str1

  }

  getDescribe(describe) {

    if (describe.indexOf("txt_") > -1) {
      let temp = describe.split(";");
      let str = '';
      for (let i = 0; i < temp.length; i++) {
        if (i <= 1 && temp[i].length > 4) {
          str = str + intl.get(temp[i]);
        }

      }
      return str

    } else {
      return describe;
    }
  }

  returnDescribe(suggestion, describe, item, index, model_number) {
    if (describe == 'txt_chassis_ok' && model_number !== 'michelin.tyrescan.ts004' && model_number !== 'michelin.tyrescan.ts005') {
      return
    }

    let key1, key2
    if (describe.startsWith('LF')) {
      key1 = describe.substring(0, 2)
      key2 = describe.substring(2, describe.length)
    } else if (describe.startsWith('RF')) {
      key1 = describe.substring(0, 2)
      key2 = describe.substring(2, describe.length)
    } else if (describe.startsWith('LB')) {
      key1 = describe.substring(0, 2)
      key2 = describe.substring(2, describe.length)
    } else if (describe.startsWith('RB')) {
      key1 = describe.substring(0, 2)
      key2 = describe.substring(2, describe.length)
    } else if (describe.startsWith('FF')) {
      key1 = describe.substring(0, 2)
      key2 = describe.substring(2, describe.length)
    } else if (describe.startsWith('BB')) {
      key1 = describe.substring(0, 2)
      key2 = describe.substring(2, describe.length)
    } else {
      key1 = ''
      key2 = describe
    }

    if (model_number == 'dt.tyrescan.ts004') {

      if (key2 == 'txt_tire_age_3') {
        key2 = 'txt_tire_age_6'
      }
      if (key2 == 'txt_tire_age_5') {
        key2 = 'txt_tire_age_8'
      }
    }
    let key1str = key1 ? intl.get(key1) : ''
    let redarrs = ['严重磨损', '嚴重磨損', '异常', '中间', '中間', '外侧', '外側', '羽状', '羽狀', '内侧', '內側', '8年', '5年', '装反', '裝反', '两边', '兩邊', '严重外伤', '嚴重外傷', '请检查轮胎磨损情况', '請檢查輪胎磨損情况', '请检查轮胎外观情况', '請檢查輪胎外觀情况', '轴头橡胶老化', '减震器漏油', '严重', '嚴重']

    let key2str = suggestion.length >= 4 ? intl.get(key2) : this.getDescribe(key2)
    if (!key2str) {
      key2str = this.getDescribe(key2)
    }
    // let str = key1str + key2str
    redarrs.map(item => {
      if (key2str.indexOf(item) !== -1) {
        key2str = key2str.replace(new RegExp(item, "g"), '<*>' + item + '<*>')
      }
    })
    let key2Arr = key2str.split('<*>')
    console.log(key2Arr)
    let tempitem = item
    if (tempitem.title === 'txt_chassis_check' && model_number === 'dach.tyrescan.ts004')
      return
    let lang = intl.options.currentLocale
    return (
      <p className='cnt' key={index}>
        <span>{tempitem.title.indexOf("txt_") > -1 ? intl.get(tempitem.title) : tempitem.title}：</span>
        <span className={lang.includes("zh") ? 'redspan' : ''}>{key1str} </span>
        {key2Arr.map((item, index) => {
          let temp = item;

          if (redarrs.indexOf(temp) !== -1) {
            return (<span className='redspan' key={index}>{temp}</span>)
          } else {
            return (<span key={index}>{temp}</span>)
          }
        })}
      </p>
    )

  }

  //解析目的：
  getpurposeStr(data) {
    if (data == 'purp_wash') {
      return intl.get('txt_xichemeirong')
    } else if (data == 'purp_alignment') {
      return intl.get('txt_sldw')
    } else if (data == 'purp_replace') {
      return intl.get('txt_guenghuanluntai')
    } else if (data == 'purp_tireservice') {
      return intl.get('txt_tireservice')
    } else if ((data === 'purp_maintain') || (data === 'purp_vehicle_inspection')) {
      return intl.get('txt_weixiubaoyang')
    } else {
      return intl.get('txt_qt')
    }
  }

  // 获取检测报告详情
  getRecordDetail() {
    Api.getRecordDetail(this.props.match.params.uuid).then(res => {
      if (res.data.code === 0) {
        //  intl.options.currentLocale = res.data.data.report ? res.data.data.report.language ? res.data.data.report.language : 'zh' : 'zh'
        //    this.forceUpdate()
        this.setState({
          report: res.data.data.report,
          language: res.data.data.report ? res.data.data.report.language : 'zh'
        })

        if (res.data.data.report.model_number && res.data.data.report.model_number.includes("cormach")){
          this.setState({cormach:true})
        }

        if (res.data.data.report.model_number == 'taiwan.tyrescan.ts004') {
          intl.options.currentLocale = 'zh_TW'
          this.forceUpdate()
        }


        //window.postMessage(JSON.stringify(param),'*')
      } else {
        console.log(res.data.message);
      }
    }).catch(err => {
      // console.log(err.request);
      if(err.request){
        console.log(err.request);
        if(err.request.readyState == 4 && err.request.status == 0){
          Api.getRecordDetail(this.props.match.params.uuid).then(res => {
            if (res.data.code === 0) {
              //  intl.options.currentLocale = res.data.data.report ? res.data.data.report.language ? res.data.data.report.language : 'zh' : 'zh'
              //    this.forceUpdate()
              this.setState({
                report: res.data.data.report,
                language: res.data.data.report ? res.data.data.report.language : 'zh'
              });

              if (res.data.data.report.model_number == 'taiwan.tyrescan.ts004') {
                intl.options.currentLocale = 'zh_TW'
                this.forceUpdate()
              }


              //window.postMessage(JSON.stringify(param),'*')
            } else {
              console.log(res.data.message);
            }
          })
        }
      }
    });
  }
}


const Tyre = props => {
  const modelnumber = props.model
  const _data = props.data;
  const green = "#36B37E";
  const yellow = "#FFAD26"
  const red = "#FF5230"
  let tyreunit = props.tyreunit;
  let wear_threshold = props.wear_threshold;
  _data.lf.position = { left: 20, top: 60 };
  _data.rf.position = { right: 20, top: 60 };
  _data.lb.position = { left: 20, top: 160 };
  _data.rb.position = { right: 20, top: 160 };

  _data.lf.desc = { left: 0, top: -55 };
  _data.rf.desc = { left: 0, top: -55 };
  _data.lb.desc = { left: 0, top: 110 };
  _data.rb.desc = { left: 0, top: 110 };

  // 返回轮胎位置
  const returnTyrePosition = key => {
    switch (key) {
      case "lf":
        return intl.get('txt_zqlun');
      case "lb":
        return intl.get('txt_zhlun');
      case "rf":
        return intl.get('txt_yqlun');
      case "rb":
        return intl.get('txt_yhlun');
    }
  };

  // 返回轮胎状态
  const returnTyreStatus = (data, status) => {
    if (data === null) {
      return {
        text: intl.get('txt_ltwjc'),
        color: "#FF5230"
      };
    }
    switch (status) {
      case "high":
        return {
          text: intl.get('txt_replace'),
          color: "#FF5230"
        };
      case "middle":
        return {
          text: intl.get('txt_Border'),
          color: "#FFAD26"
        };
      case "low":
        return {
          text: intl.get('txt_GoodState'),
          color: "#36B37E"
        };
    }
  };


  // 返回轮胎状态
  const returnTyreStatusLast = (thisdata, thisstatus, status) => {
    if (!thisstatus || thisstatus == "low") {
      return {
        text: '',
        color: red
      };
    } else if (thisstatus == 'middle' && status == "low") {

      return {
        text: intl.get('txt_GoodState'),
        color: green
      };
    } else if (thisstatus == "high" && status == "low") {
      return {
        text: intl.get('txt_GoodState'),
        color: yellow
      };
    } else if (thisstatus == "high" && status == "middle") {
      return {
        text: intl.get('txt_Border'),
        color: red
      };
    } else {
      return {
        text: '',
        color: red
      };

    }
  };


  // 返回轮胎平均值
  const returnTyrePoint = data => {
    let _obj = [];
    let _newObj = [];
    if (data) {
      _obj = _.chunk(data, 4);
      _obj = _obj.map(item => {
        _newObj.push(item[1]);
      });
      _newObj = _newObj.map(item => _.toNumber((item / 10).toFixed(1)));
    }

    return _newObj;
  };

  //返回轮胎平均值，针对leader.tyrescan.ts008
  const returnAverage = data => {
    let arr = returnTyrePoint(data);
    if (arr.length <= 0) {
      return -1
    } else if (arr.length > 0 && arr.length <= 2) {
      let total = 0
      arr.map(item => {
        total = total + item
      })
      let average = total / arr.length
      console.log('a=' + average)
      return average.toFixed(2);
    } else {
      let max = Math.max.apply(null, arr)
      let min = Math.min.apply(null, arr)
      let total = 0
      arr.map(item => {
        total = total + item
      })
      total = total - max - min
      let average = total / (arr.length - 2)
      console.log('a=' + average + 'max=' + max + 'min=' + min)
      return average.toFixed(2);
    }
  }

  const returnTyre = (status, data) => {
    let _data;
    if (!data) {
      _data = 1;
    } else {
      _data = data.length / 4;
    }
    if (status === "high") {
      return (
        <div style={{ textAlign: "center" }}>
          {_data >= 4 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-red-1.png")}
              alt=""
            />
          )}
          {_data === 3 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-red-2.png")}
              alt=""
            />
          )}
          {_data === 2 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-red-3.png")}
              alt=""
            />
          )}
          {_data === 1 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-default.png")}
              alt=""
            />
          )}
        </div>
      );
    }
    if (status === "middle") {
      return (
        <div style={{ textAlign: "center" }}>
          {_data >= 4 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-yellow-1.png")}
              alt=""
            />
          )}
          {_data === 3 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-yellow-2.png")}
              alt=""
            />
          )}
          {_data === 2 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-yellow-3.png")}
              alt=""
            />
          )}
          {_data === 1 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-default.png")}
              alt=""
            />
          )}
        </div>
      );
    }
    if (status === "low") {
      return (
        <div style={{ textAlign: "center" }}>
          {_data >= 4 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-green-1.png")}
              alt=""
            />
          )}
          {_data === 3 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-green-2.png")}
              alt=""
            />
          )}
          {_data === 2 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-green-3.png")}
              alt=""
            />
          )}
          {_data === 1 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-default.png")}
              alt=""
            />
          )}
        </div>
      );
    }
  };

  // 返回 信息
  const returnTyreInfo = (data, index) => {
    if (data) {
      return data.split(/,|，/)[index] ? data.split(/,|，/)[index] : "-";
    }
    return "-";
  };


  // 返回dot颜色
  const returnDotStatus = (tyredata, index) => {
    const data = returnTyreInfo(tyredata, index)
    // console.log('returnDotStatus data:' + data);
    if ((data === null) || (data.length !== 4)) {
      return {
        color: red
      };
    }
    var date = new Date();

    var year = date.getFullYear();
    var month = (date.getMonth() + 1);
    var day = date.getDate();
    var daysnow = year * 365 + month * 30 + day;

    var tmpdata = data.slice(2);
    var tmpweek = data;

    console.log('tmpdata:' + tmpdata + ' ;tmpweek:' + tmpweek);
    var tmpdays = (2000 + Number(tmpdata)) * 365 + (Number(tmpweek) - Number(tmpdata)) / 100 * 7;
    console.log('1tmpdata:' + Number(tmpdata) + ' ;1tmpweek:' + Number(tmpweek));
    console.log('daysnow:' + daysnow + ' ;tmpdays:' + tmpdays);
    if (modelnumber == 'dt.tyrescan.ts004') {
      if (daysnow > (tmpdays + 365 * 8)) {

        return {
          color: red
        };
      } else if (daysnow > (tmpdays + 365 * 6)) {

        return {
          color: yellow
        };
      } else {
        return {
          color: green
        };
      }
    } else {
      if (daysnow > (tmpdays + 365 * 5)) {
        return {
          color: red
        };
      } else if (daysnow > (tmpdays + 365 * 3)) {
        return {
          color: yellow
        };
      } else {
        return {
          color: green
        };
      }
    }

  };

  const returnSeason = data => {
    if (!data) {
      return ''
    } else {
      return intl.get('txt_' + data)
    }
  }


  const returnPointColor = data => {
    let point = tyreunit == 'unit_in' ? (data * 1.25984).toFixed(1) : data;
    if (wear_threshold && wear_threshold.low && wear_threshold.high) {
      let low = wear_threshold.low / 10;
      let high = wear_threshold.high / 10;
      if (tyreunit && tyreunit == 'unit_in') {
        low = (low * 1.25984).toFixed(1)
        high = (high * 1.25984).toFixed(1)
      }
      if (point < low) {
        return { color: red }
      } else if (point >= high) {
        return { color: green }
      } else {
        return { color: yellow }
      }
    } else {
      return { color: '#000000' }
    }
  }

  return (
    <div>
      {Object.entries(_data).map((item, index) => (
        <div
          style={Object.assign(item[1].position, { position: "absolute" })}
          key={index}
        >
          {modelnumber !== 'leader.tyrescan.ts008' && (<div>
            <div style={Object.assign(item[1].desc, { position: "absolute", marginTop: index > 1 ? '10px' : '2px' })}>
              <div className="wheelCarSubDesc1 singleline">
                <label
                  className="wheelCarDesc__label1 "
                  style={{
                    color: returnTyreStatus(item[1].data, item[1].color).color
                  }}
                >
                  {returnTyrePosition(item[0])}：
                </label>
                <span className="wheelCarDesc__cnt  singleline">
                  {returnSeason(item[1].season)}
                </span>
              </div>

              <div className="wheelCarSubDesc1">
                <label className="wheelCarDesc__label1 singleline">{intl.get('txt_pinpai')}：</label>
                <span className="wheelCarDesc__cnt">
                  {returnTyreInfo(item[1].info, 1)}
                </span>
              </div>

              <div className="wheelCarSubDesc1">
                <label className="wheelCarDesc__label1 singleline">
                  {intl.get('txt_guige') + '：'}
                </label>
                <span className="wheelCarDesc__cnt">
                  {returnTyreInfo(item[1].info, 2)}
                </span>
              </div>

              <div className="wheelCarSubDesc1">
                <label className="wheelCarDesc__label1 singleline">
                  {intl.get('txt_Wear') + '：'}
                </label>
                <span className="wheelCarDesc__cnt  singleline" style={{ color: returnTyreStatus(item[1].data, item[1].color).color }}>
                  {returnTyreStatus(item[1].data, item[1].color).text}
                </span>
              </div>

              <div className="wheelCarSubDesc1">
                <label className="wheelCarDesc__label1">DOT：</label>
                <span style={{ color: returnDotStatus(item[1].info, 0).color }} className="wheelCarDesc__cnt">
                  {returnTyreInfo(item[1].info, 0)}
                </span>
              </div>

            </div>
            <div style={{ marginTop: index > 1 ? '40px' : '60px' }}>
              {returnTyre(item[1].color, item[1].data)}
              <p
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: 112,
                  marginTop: -8,

                }}
              >
                {returnTyrePoint(item[1].data).map((point, index) => (
                  <span style={{ fontSize: "12px" }} key={index}>
                    {tyreunit == 'unit_in' ? (point * 1.25984).toFixed(1) : point}
                  </span>
                ))}
              </p>
            </div>
          </div>)}

          {modelnumber == 'leader.tyrescan.ts008' && (<div>
            <div style={Object.assign(item[1].desc, { position: "absolute", marginTop: index > 1 ? '10px' : '2px' })}>
              <div className="wheelCarDesc1">
                <label
                  className="wheelCarDesc__label1"
                  style={{
                    color: returnTyreStatus(item[1].data, item[1].color).color
                  }}
                >
                  {returnTyrePosition(item[0])}：
                </label>

              </div>

              <div className="wheelCarDesc1" style={{ color: returnTyreStatus(item[1].data, item[1].color).color }}>
                {returnTyreStatus(item[1].data, item[1].color).text}
              </div>
              <div className="wheelCarDesc1">
                <label className="wheelCarDesc__label1 singleline">
                  {intl.get('txt_pingjunzhi') + ':'}
                </label>
                <span className="wheelCarDesc__cnt" style={{ color: returnTyreStatus(item[1].data, item[1].color).color }}>
                  {returnAverage(item[1].data) == -1 ? intl.get('txt_NoData') : returnAverage(item[1].data)}
                </span>
              </div>


            </div>
            <div style={{ marginTop: index > 1 ? '20px' : '30px' }}>

              <p
                style={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: "space-between",
                  alignItems: "center",
                  width: 112,
                  marginTop: -8,

                }}
              >
              </p>
            </div>
          </div>)}
        </div>
      ))}
    </div>
  );
};

//台湾
const Tyre_TW = props => {
  const _data = props.data;
  const green = "#36B37E";
  const yellow = "#FFAD26"
  const red = "#FF5230"
  _data.lf.position = { left: 20, top: 50 };
  _data.rf.position = { right: 20, top: 50 };
  _data.lb.position = { left: 20, top: 150 };
  _data.rb.position = { right: 20, top: 150 };

  _data.lf.desc = { left: 0, top: -20 };
  _data.rf.desc = { left: 0, top: -20 };
  _data.lb.desc = { left: 0, top: 80 };
  _data.rb.desc = { left: 0, top: 80 };

  // 返回轮胎位置
  const returnTyrePosition = key => {
    switch (key) {
      case "lf":
        return intl.get('txt_zqlun');
      case "lb":
        return intl.get('txt_zhlun');
      case "rf":
        return intl.get('txt_yqlun');
      case "rb":
        return intl.get('txt_yhlun');
    }
  };

  // 返回轮胎状态
  const returnTyreStatus = (data, status) => {
    if (data === null) {
      return {
        text: intl.get('txt_ltwjc'),
        color: "#FF5230"
      };
    }
    switch (status) {
      case "high":
        return {
          text: intl.get('txt_replace'),
          color: "#FF5230"
        };
      case "middle":
        return {
          text: intl.get('txt_Border'),
          color: "#FFAD26"
        };
      case "low":
        return {
          text: intl.get('txt_GoodState'),
          color: "#36B37E"
        };
    }
  };


  // 返回轮胎状态
  const returnTyreStatusLast = (thisdata, thisstatus, status) => {
    if (!thisstatus || thisstatus == "low") {
      return {
        text: '',
        color: red
      };
    } else if (thisstatus == 'middle' && status == "low") {

      return {
        text: intl.get('txt_GoodState'),
        color: green
      };
    } else if (thisstatus == "high" && status == "low") {
      return {
        text: intl.get('txt_GoodState'),
        color: yellow
      };
    } else if (thisstatus == "high" && status == "middle") {
      return {
        text: intl.get('txt_Border'),
        color: red
      };
    } else {
      return {
        text: '',
        color: red
      };

    }
  };


  // 返回轮胎平均值
  const returnTyrePoint = data => {
    let _obj = [];
    let _newObj = [];
    if (data) {
      _obj = _.chunk(data, 4);
      _obj = _obj.map(item => {
        _newObj.push(item[1]);
      });
      _newObj = _newObj.map(item => _.toNumber((item / 10).toFixed(1)));
    }
    return _newObj;
  };

  const returnTyre = (status, data) => {
    let _data;
    if (!data) {
      _data = 1;
    } else {
      _data = data.length / 4;
    }
    if (status === "high") {
      return (
        <div style={{ textAlign: "center" }}>
          {_data >= 4 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-red-1.png")}
              alt=""
            />
          )}
          {_data === 3 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-red-2.png")}
              alt=""
            />
          )}
          {_data === 2 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-red-3.png")}
              alt=""
            />
          )}
          {_data === 1 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-default.png")}
              alt=""
            />
          )}
        </div>
      );
    }
    if (status === "middle") {
      return (
        <div style={{ textAlign: "center" }}>
          {_data >= 4 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-yellow-1.png")}
              alt=""
            />
          )}
          {_data === 3 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-yellow-2.png")}
              alt=""
            />
          )}
          {_data === 2 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-yellow-3.png")}
              alt=""
            />
          )}
          {_data === 1 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-default.png")}
              alt=""
            />
          )}
        </div>
      );
    }
    if (status === "low") {
      return (
        <div style={{ textAlign: "center" }}>
          {_data >= 4 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-green-1.png")}
              alt=""
            />
          )}
          {_data === 3 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-green-2.png")}
              alt=""
            />
          )}
          {_data === 2 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-green-3.png")}
              alt=""
            />
          )}
          {_data === 1 && (
            <img
              className="tyre"
              src={require("../../assets/report/tyre-default.png")}
              alt=""
            />
          )}
        </div>
      );
    }
  };

  // 返回 信息
  const returnTyreInfo = (data, index) => {
    if (data) {
      return data.split(/,|，/)[index] ? data.split(/,|，/)[index] : "-";
    }
    return "-";
  };


  // 返回dot颜色
  const returnDotStatus = (tyredata, index) => {
    const data = returnTyreInfo(tyredata, index)
    console.log('returnDotStatus data:' + data);
    if ((data === null) || (data.length !== 4)) {
      return {
        color: red
      };
    }
    var date = new Date();

    var year = date.getFullYear();
    var month = (date.getMonth() + 1);
    var day = date.getDate();
    var daysnow = year * 365 + month * 30 + day;

    var tmpdata = data.slice(2);
    var tmpweek = data;

    console.log('tmpdata:' + tmpdata + ' ;tmpweek:' + tmpweek);
    var tmpdays = (2000 + Number(tmpdata)) * 365 + (Number(tmpweek) - Number(tmpdata)) / 100 * 7;
    console.log('1tmpdata:' + Number(tmpdata) + ' ;1tmpweek:' + Number(tmpweek));
    console.log('daysnow:' + daysnow + ' ;tmpdays:' + tmpdays);
    if (daysnow > (tmpdays + 365 * 5)) {
      return {
        color: red
      };
    } else if (daysnow > (tmpdays + 365 * 3)) {
      return {
        color: yellow
      };
    } else {
      return {
        color: green
      };
    }
  };

  return (
    <div>
      {Object.entries(_data).map((item, index) => (
        <div
          style={Object.assign(item[1].position, { position: "absolute" })}
          key={index}
        >
          <div style={Object.assign(item[1].desc, { position: "absolute", marginTop: index > 1 ? '10px' : '2px' })}>
            <div className="wheelCarDesc">
              <label
                className="wheelCarDesc__label"
                style={{
                  color: returnTyreStatus(item[1].data, item[1].color).color
                }}
              >
                {returnTyrePosition(item[0])}：
              </label>

            </div>


          </div>
          <div >
            {returnTyre(item[1].color, item[1].data)}
            <p
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                alignItems: "center",
                width: 112,
                marginTop: -8,

              }}
            >
              {returnTyrePoint(item[1].data).map((point, index) => (
                <span style={{ fontSize: "12px", }} key={index}>
                  {point}
                </span>
              ))}
            </p>
          </div>
        </div>
      ))}
    </div>
  );
};


// install
const InstallView = props => {
  let data = props.data;

  const isNormal = (data) => {
    let Arr = [data.lf, data.rf, data.lb, data.rb]
    let flag = true
    Arr.map(item => {
      if (item) {
        let temp = item.split(',');
        if (temp[temp.length - 1] == "install_abnormal") {
          flag = false
        }
      }

    })
    return flag;

  }

  return (
    <div style={{ flexDirection: "row", paddingLeft: 20, paddingRight: 20, marginTop: 10, alignItems: "flex-start" }}>
      <span style={{ fontSize: 14, fontWeight: "bold", }}>{intl.get('txt_ltazhuang')}</span>
      <span style={{ fontSize: 14, fontWeight: "bold", color: isNormal(data) ? '#36B37E' : "#FF5230" }}>{isNormal(data) ? intl.get('txt_zc') : intl.get('txt_ltfz')}</span>

    </div>
  );
};

// 轮子颜色顺序 左前，右前，左后，右后
// low, 绿色
// middle，黄色
// high，红色
const Frame = props => {
  let _data = {};
  let lang = intl.options.currentLocale
  if (props.data) {
    _data = props.data;
    _data.lf.position = { marginLeft: -25, top: 28 };
    _data.rf.position = { marginLeft: 25, top: 28 };
    _data.lb.position = { marginLeft: -25, top: lang.includes("zh") || lang == 'ja' || lang == 'en' ? 97 : 117 };
    _data.rb.position = { marginLeft: 25, top: lang.includes("zh") || lang == 'ja' || lang == 'en' ? 97 : 117 };
    _data.lf.desc = {
      position: { left: -140 },
      title: intl.get('txt_hwmsjh')
    };
    _data.rf.desc = {
      position: { right: -140 },
      title: intl.get('txt_hwmsjh')
    };
    _data.lb.desc = {
      position: { left: -140 },
      title: intl.get('txt_hwmsjh')
    };
    _data.rb.desc = {
      position: { right: -140 },
      title: intl.get('txt_hwmsjh')
    };
  }

  // 返回 信息
  const returnTyreInfo = (data, index) => {
    if (data) {
      return data.split(/,|，/)[index] ? data.split(/,|，/)[index] : "-";
    }
    return "-";
  };
  if (Object.prototype.toString.call(props.conclusion) === "[object Array]") {
    props.conclusion.forEach(item => {
      if (item.title.indexOf("LF") > -1) {
        if (item.title.indexOf('txt_') > -1) {
          _data.lf.desc.title = intl.get(item.title.slice(2))

        } else {
          _data.lf.desc.title = item.title.slice(2);
        }
      }
      if (item.title.indexOf("RF") > -1) {
        if (item.title.indexOf('txt_') > -1) {
          _data.rf.desc.title = intl.get(item.title.slice(2))
        } else {
          _data.rf.desc.title = item.title.slice(2);
        }
      }
      if (item.title.indexOf("LB") > -1) {
        if (item.title.indexOf('txt_') > -1) {

          _data.lb.desc.title = intl.get(item.title.slice(2))
        } else {
          _data.lb.desc.title = item.title.slice(2);
        }
      }
      if (item.title.indexOf("RB") > -1) {
        if (item.title.indexOf('txt_') > -1) {
          _data.rb.desc.title = intl.get(item.title.slice(2))
        } else {
          _data.rb.desc.title = item.title.slice(2);
        }
      }
      if (item.title.indexOf('FF') > -1) {
        _data.lf.desc.title = intl.get('txt_pianmoyichang')
        _data.lf.desc.color = '#FF5230'
        _data.lf.desc.img = require("../../assets/report/tyre-high.png")
        _data.rf.desc.title = intl.get('txt_pianmoyichang')
        _data.rf.desc.color = '#FF5230'
        _data.rf.desc.img = require("../../assets/report/tyre-high.png")
      }
      if (item.title.indexOf('BB') > -1) {
        _data.lb.desc.title = intl.get('txt_pianmoyichang')
        _data.lb.desc.color = '#FF5230'
        _data.lb.desc.img = require("../../assets/report/tyre-high.png")
        _data.rb.desc.title = intl.get('txt_pianmoyichang')
        _data.rb.desc.color = '#FF5230'
        _data.rb.desc.img = require("../../assets/report/tyre-high.png")
      }
    });
  }

  if (returnTyreInfo(_data.lf.trauma, 3).indexOf('trauma_eattyre') !== -1) {
    if (returnTyreInfo(_data.lf.trauma, 5) == 'damage_low') {
      _data.lf.desc.title = intl.get('txt_pianmoyichang')
      _data.lf.desc.color = '#FFAD26'
      _data.lf.desc.img = require("../../assets/report/tyre-middle.png")
    } else {
      _data.lf.desc.title = intl.get('txt_pianmoyichang')
      _data.lf.desc.color = '#FF5230'
      _data.lf.desc.img = require("../../assets/report/tyre-high.png")
    }
  }
  if (returnTyreInfo(_data.rf.trauma, 3).indexOf('trauma_eattyre') !== -1) {
    if (returnTyreInfo(_data.rf.trauma, 5) == 'damage_low') {
      _data.rf.desc.title = intl.get('txt_pianmoyichang')
      _data.rf.desc.color = '#FFAD26'
      _data.rf.desc.img = require("../../assets/report/tyre-middle.png")
    } else {
      _data.rf.desc.title = intl.get('txt_pianmoyichang')
      _data.rf.desc.color = '#FF5230'
      _data.rf.desc.img = require("../../assets/report/tyre-high.png")
    }
  }

  if (returnTyreInfo(_data.rb.trauma, 3).indexOf('trauma_eattyre') !== -1) {
    if (returnTyreInfo(_data.rb.trauma, 5) == 'damage_low') {
      _data.rb.desc.title = intl.get('txt_pianmoyichang')
      _data.rb.desc.color = '#FFAD26'
      _data.rb.desc.img = require("../../assets/report/tyre-middle.png")
    } else {
      _data.rb.desc.title = intl.get('txt_pianmoyichang')
      _data.rb.desc.color = '#FF5230'
      _data.rb.desc.img = require("../../assets/report/tyre-high.png")
    }
  }

  if (returnTyreInfo(_data.lb.trauma, 3).indexOf('trauma_eattyre') !== -1) {
    if (returnTyreInfo(_data.lb.trauma, 5) == 'damage_low') {
      _data.lb.desc.title = intl.get('txt_pianmoyichang')
      _data.lb.desc.color = '#FFAD26'
      _data.lb.desc.img = require("../../assets/report/tyre-middle.png")
    } else {
      _data.lb.desc.title = intl.get('txt_pianmoyichang')
      _data.lb.desc.color = '#FF5230'
      _data.lb.desc.img = require("../../assets/report/tyre-high.png")
    }
  }
  let suggestion = props.suggestion
  if (suggestion[1].describe.indexOf('FF') > -1) {
    _data.lf.desc.title = intl.get('txt_pianmoyichang')
    _data.lf.desc.color = '#FF5230'
    _data.lf.desc.img = require("../../assets/report/tyre-high.png")
    _data.rf.desc.title = intl.get('txt_pianmoyichang')
    _data.rf.desc.color = '#FF5230'
    _data.rf.desc.img = require("../../assets/report/tyre-high.png")
  }
  if (suggestion[1].describe.indexOf('BB') > -1) {
    _data.lb.desc.title = intl.get('txt_pianmoyichang')
    _data.lb.desc.color = '#FF5230'
    _data.lb.desc.img = require("../../assets/report/tyre-high.png")
    _data.rb.desc.title = intl.get('txt_pianmoyichang')
    _data.rb.desc.color = '#FF5230'
    _data.rb.desc.img = require("../../assets/report/tyre-high.png")
  }

  // 返回轮胎颜色
  const returnColor = data => {
    if (data === null) {
      return;
    }
    return data === "low"
      ? {
        color: "#36B37E",
        img: require("../../assets/report/tyre-low.png")
      }
      : data === "middle"
        ? {
          color: "#FFAD26",
          img: require("../../assets/report/tyre-middle.png")
        }
        : {
          color: "#FF5230",
          img: require("../../assets/report/tyre-high.png")
        };
  };

  // 返回轮胎位置
  const returnTyrePosition = name => {
    switch (name) {
      case "lf":
        return intl.get('txt_zqlun');
      case "lb":
        return intl.get('txt_zhlun');
      case "rf":
        return intl.get('txt_yqlun');
      case "rb":
        return intl.get('txt_yhlun');
    }
  };

  //返回轮胎建议
  const returnjianyi = (data, conclusion) => {
    if (conclusion && conclusion[0] && (conclusion[0].title.startsWith('BB') || conclusion[0].title.startsWith('FF'))) {
      let str = conclusion[0].title
      let key1str = intl.get(str.substring(0, 2));
      let key2str = intl.get(str.substring(2, str.length));
      key2str = key2str.replace(new RegExp('异常', "g"), '<*>' + '异常' + '<*>')
      let key2arr = key2str.split('<*>')
      return <p className='cnt'> {intl.get('txt_jianyi')} <span className='redspan'>{key1str}</span> {key2arr.map((item, index) => {
        if (item == '异常') {
          return (<span key={index} className='redspan'>{item}</span>)
        } else {
          return (<span key={index} >{item}</span>)
        }

      })}  </p>
    }
    if (data == null) {
      return (<p style={{ fontSize: 14, lineHeight: 1 }}> {intl.get('txt_jianyi') + intl.get('txt_jianyineirongzc')}</p>)
    }

    let str = intl.get('txt_jianyineirongzc');
    data.map(item => {
      if (item[1].data == 'middle' || item[1].data == 'high') {

        str = intl.get('txt_jianyineirong')

      }

    })

    return (<p style={{ fontSize: 14, lineHeight: 1 }}> {intl.get('txt_jianyi') + str}</p>)

  }
  let isuse = lang.includes("zh") || lang == 'ja' || lang == 'en'
  return (
    <div style={{
      display: "flex",
      flexDirection: "column"
    }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          position: "relative",
          flexDirection: "column"
        }}
      >
        <img
          style={{ width: 50, height: 150, objectFit: "contain" }}
          src={require("../../assets/report/reportcar1.png")}
          alt=""
        />
        {Object.entries(_data).map((item, index) => (
          <div
            style={Object.assign(item[1].position, { position: "absolute" })}
            key={item[0]}
          >
            <div className="frameDesc" style={item[1].desc.position}>
              <p>{returnTyrePosition(item[0])}：</p>
              <p style={{ color: item[1].desc.color ? item[1].desc.color : returnColor(item[1].data).color, lineHeight: 1, maxHeight: 60 }}>
                {item[1].desc.title}
              </p>
            </div>
            <img
              style={{ width: 15, height: 25, objectFit: "contain", position: 'relative', top: (index > 1 && !isuse) ? -15 : 0 }}
              src={item[1].desc.img ? item[1].desc.img : returnColor(item[1].data).img}
              alt=""
            />
          </div>
        ))}

        {/* {props.transposition && (
          <div>
            {(props.transposition.includes("LF2RF") ||
              props.transposition.includes("LB2RB")) && (
                <img
                  src={require("../../assets/report/huanwei_h.png")}
                  style={{
                    position: "absolute",
                    left: "47.5vw",
                    top: 120,
                    width: 20,
                    objectFit: "contain"
                  }}
                  alt=""
                />
              )}
            {(props.transposition.includes("LF2RB") ||
              props.transposition.includes("RB2LF")) && (
                <img
                  src={require("../../assets/report/huanwei_x_left.png")}
                  style={{
                    position: "absolute",
                    left: "45vw",
                    top: 55,
                    height: 40,
                    objectFit: "contain"
                  }}
                  alt=""
                />
              )}
            {(props.transposition.includes("RF2LB") ||
              props.transposition.includes("LB2RF")) && (
                <img
                  src={require("../../assets/report/huanwei_x_right.png")}
                  style={{
                    position: "absolute",
                    left: "45vw",
                    top: 55,
                    height: 40,
                    objectFit: "contain"
                  }}
                  alt=""
                />
              )}
            {props.transposition.includes("LF2LB") && (
              <img
                src={require("../../assets/report/huanwei_v.png")}
                style={{
                  position: "absolute",
                  left: "42vw",
                  top: 65,
                  height: 20,
                  objectFit: "contain"
                }}
                alt=""
              />
            )}
            {props.transposition.includes("RF2RB") && (
              <img
                src={require("../../assets/report/huanwei_v.png")}
                style={{
                  position: "absolute",
                  left: "55vw",
                  top: 65,
                  height: 20,
                  objectFit: "contain"
                }}
                alt=""
              />
            )}
          </div>
        )} */}
      </div>
      {/* TODO:添加总结 */}


    </div>
  );
};

// 刹车距离组件
const BrakeBar = props => {
  let level = props.level;
  let images = [
    require(`../../assets/report/item_2_1.png`),
    require(`../../assets/report/item_2_2.png`),
    require(`../../assets/report/item_2_3.png`),
    require(`../../assets/report/item_2_4.png`),
    require(`../../assets/report/item_2_5.png`),
    require(`../../assets/report/item_2_6.png`),
    require(`../../assets/report/item_2_7.png`),
    require(`../../assets/report/item_2_8.png`),
    require(`../../assets/report/item_2_9.png`),
    require(`../../assets/report/item_2_10.png`),
  ]
  let imagesll = [
    require(`../../assets/report/item_2_1ll.png`),
    require(`../../assets/report/item_2_2ll.png`),
    require(`../../assets/report/item_2_3ll.png`),
    require(`../../assets/report/item_2_4ll.png`),
    require(`../../assets/report/item_2_5ll.png`),
    require(`../../assets/report/item_2_6ll.png`),
    require(`../../assets/report/item_2_7ll.png`),
    require(`../../assets/report/item_2_8ll.png`),
    require(`../../assets/report/item_2_9ll.png`),
    require(`../../assets/report/item_2_10ll.png`),
  ]
  return (
    <img
      style={{ width: "100%", marginTop: -20, objectFit: "contain" }}
      src={intl.options.currentLocale == 'zh' ? images[level - 1] : imagesll[level - 1]}
      alt=""
    />
  );
};

// 轮胎颜色
const TyreColor = props => {
  const _data = props.status;
  _data.lf.position = { left: -5, top: 85 };
  _data.rf.position = { right: -5, top: 85 };
  _data.lb.position = { left: -5, top: 165 };
  _data.rb.position = { right: -5, top: 165 };

  // 返回轮胎状态
  const returnTyreStatus = status => {
    switch (status) {
      case "high":
        return (
          <img
            style={{ objectFit: "contain" }}
            src={require("../../assets/report/tyre-red.png")}
            alt=""
          />
        );
      case "middle":
        return (
          <img
            style={{ objectFit: "contain" }}
            src={require("../../assets/report/tyre-yellow.png")}
            alt=""
          />
        );
      case "low":
        return (
          <img
            style={{ objectFit: "contain" }}
            src={require("../../assets/report/tyre-green.png")}
            alt=""
          />
        );
    }
  };

  return (
    <div style={{ zIndex: -1 }}>
      {Object.entries(_data).map((item, index) => (
        <div
          style={Object.assign(item[1].position, {
            position: "absolute",
            width: 20,
            height: 40
          })}
          key={index}
        >
          {returnTyreStatus(item[1].color)}
        </div>
      ))}
    </div>
  );
};

// 轮胎外伤颜色
const TyreColor1 = props => {
  const _data = props.status;
  _data.lf.position = { left: -5, top: 85 };
  _data.rf.position = { right: -5, top: 85 };
  _data.lb.position = { left: -5, top: 165 };
  _data.rb.position = { right: -5, top: 165 };
  // 返回 信息
  const returnTyreInfo = (data, index) => {
    if (data) {
      return data.split(/,|，/)[index] ? data.split(/,|，/)[index] : "-";
    }
    return "-";
  };
  // 返回轮胎状态
  const returnTyreStatus = status => {
    // console.log('status=' + status);
    let data = returnTyreInfo(status, 3)
    let cd = returnTyreInfo(status, 5)
    if (data && data.indexOf('trauma_normal') == -1) {
      if (cd && cd == 'damage_low') {
        return (
          <img
            style={{ objectFit: "contain" }}
            src={require("../../assets/report/tyre-yellow.png")}
            alt=""
          />
        );
      } else if (cd && cd == 'damage_high') {
        return (
          <img
            style={{ objectFit: "contain" }}
            src={require("../../assets/report/tyre-red.png")}
            alt=""
          />
        );
      } else if (data.indexOf('trauma') == -1) {
        return (
          <img
            style={{ objectFit: "contain" }}
            src={require("../../assets/report/tyre-green.png")}
            alt=""
          />
        );
      } else {
        return (
          <img
            style={{ objectFit: "contain" }}
            src={require("../../assets/report/tyre-yellow.png")}
            alt=""
          />
        );
      }

    } else {

      return (
        <img
          style={{ objectFit: "contain" }}
          src={require("../../assets/report/tyre-green.png")}
          alt=""
        />
      );

    }
  };


  return (
    <div style={{ zIndex: -1 }}>
      {Object.entries(_data).map((item, index) => (
        <div
          style={Object.assign(item[1].position, {
            position: "absolute",
            width: 20,
            height: 40
          })}
          key={index}
        >
          {returnTyreStatus(item[1].color)}
        </div>
      ))}
    </div>
  );
};

{/** 轮胎外观 */ }
const Tyre_ltwg = props => {
  const _data = props.data;
  _data.lf.position = { left: 30, top: 60 };
  _data.rf.position = { right: 30, top: 60 };
  _data.lb.position = { left: 30, top: 180 };
  _data.rb.position = { right: 30, top: 180 };

  _data.lf.desc = { left: 0, top: -30 };
  _data.rf.desc = { right: 0, top: -30 };
  _data.lb.desc = { left: 0, top: -20 };
  _data.rb.desc = { right: 0, top: -20 };

  // 返回 信息
  const returnTyreInfo = (data, index) => {
    if (data) {
      return data.split(/,|，/)[index] ? data.split(/,|，/)[index] : "-";
    }
    return "-";
  };

  // 返回轮胎位置
  const returnTyrePosition = key => {
    switch (key) {
      case "lf":
        return intl.get('txt_zqlun');
      case "lb":
        return intl.get('txt_zhlun');
      case "rf":
        return intl.get('txt_yqlun');
      case "rb":
        return intl.get('txt_yhlun');
    }
  };

  // 返回轮胎状态
  const returnTyreStatus = (data, status) => {

    let yellow = '#FFAD26'
    if (data == null || data == '') {
      return {
        text: intl.get('txt_zcd'),
        color: '#36B37E'
      };
    } else {
      let temp = data.split(',');
      let text = temp[3];
      let color = '#FF5230';

      if (text.indexOf(';') !== -1) {
        let temptext = '';
        let tempArr = text.split(';')
        tempArr.map(item => {
          if (item == 'trauma_normal') {
            temptext = temptext + intl.get('txt_zcd')

          } else if (item == 'trauma_bulge') {
            temptext = temptext + ' ' + intl.get('txt_gubao')
          } else if (item == 'trauma_aging') {
            temptext = temptext + ' ' + intl.get('txt_laohua')
          } else if (item == 'trauma_lacerate') {
            temptext = temptext + ' ' + intl.get('txt_gelie')
          } else if (item == 'trauma_dropblock') {
            temptext = temptext + ' ' + intl.get('txt_diaokuai')
          } else if (item == 'trauma_puncture') {
            temptext = temptext + ' ' + intl.get('txt_chaungci')
          } else if (item == 'trauma_scratch') {
            temptext = temptext + ' ' + intl.get('txt_cashang')
          } else if (item == 'trauma_pinnate') {
            temptext = temptext + ' ' + intl.get('txt_pinnate_wear')
          } else if (item == 'trauma_eattyre') {
            temptext = temptext + ' ' + intl.get('txt_trauma_eattyre')
          }

        })
        text = temptext;
      } else {
        if (text == 'trauma_normal') {
          text = intl.get('txt_zcd')
          color = '#36B37E';
        } else if (text == 'trauma_bulge') {
          text = intl.get('txt_gubao')
        } else if (text == 'trauma_aging') {
          text = intl.get('txt_laohua')
        } else if (text == 'trauma_pinnate') {
          text = intl.get('txt_pinnate_wear')
        } else if (text == 'trauma_scratch') {
          text = intl.get('txt_cashang')
        } else if (text == 'trauma_puncture') {
          text = intl.get('txt_chaungci')
        } else if (text == 'trauma_dropblock') {
          text = intl.get('txt_diaokuai')
        } else if (text == 'trauma_lacerate') {
          text = intl.get('txt_gelie')
        } else if (text == 'trauma_eattyre') {
          text = intl.get('txt_trauma_eattyre')
        }
        else if (text.indexOf('trauma_other') !== -1) {
          text = text.slice(12)
        } else {
          text = intl.get('txt_zcd')
          color = '#36B37E';
        }

      }
      let cd = returnTyreInfo(data, 5)
      if (text.indexOf('trauma_normal') == -1 && cd && cd == 'damage_low') {
        color = yellow
      }
      return {
        text: text,
        color: color
      };
    }
  };

  // 轮胎图片
  const returnTyre = (data) => {
    // console.log(data)
    if (data) {
      if (data.indexOf("img1")>=0 && data.indexOf("img2")>0 && data.indexOf("img3")>0){
        let imgjson = JSON.parse(data)
        if (data.indexOf("img1")>=0 && imgjson.img2==='' && imgjson.img3===''){
          return (<img
            style={{
              width: 90,
              height: 60
            }}
            resizemode="contain"
            src={imgjson.img1==''?require("../../assets/report/noimage.png"):imgjson.img1} />);
        }else
          return (
            <div>
              <a href={imgjson.img1}>
              <img
                style={{
                  width: 30, height: 60
                }}
                resizemode="cover"
                src={imgjson.img1==''?require("../../assets/report/noimage.png"):imgjson.img1} />
              </a>
              <a href={imgjson.img2}>
                <img
                style={{
                  width: 30, height: 60,
                }}
                resizemode="cover"
                src={imgjson.img2==''?require("../../assets/report/noimage.png"):imgjson.img2} />
                </a>
                <a href={imgjson.img3}>
                <img
                style={{
                  width: 30, height: 60,
                }}
                resizemode="cover"
                src={imgjson.img3==''?require("../../assets/report/noimage.png"):imgjson.img3} />
                </a>
              </div>);
      }else{
        return (<img
          style={{
            width: 90,
            height: 60
          }}
          resizemode="contain"
          src={data} />);
      }
      
    } else {
      return (<div></div>)
    }

  };

  // 外伤正常
  const returnNomaimg = () => {

    return (<img
      style={{
        width: 90,
        height: 60
      }}
      resizemode="contain"
      src={require('../../assets/report/reportwszc.png')} />);


  };

  return (
    <div>
      {Object.entries(_data).map((item, index) => (
        <div
          style={Object.assign(item[1].position, { position: "absolute" })}
          key={index}
        >
          <div style={Object.assign(item[1].desc, { position: "absolute" })}>
            <div className="wheelCarDesc">
              <label
                className="wheelCarDesc__label"
                style={{
                  width: '100px',
                }}
              >
                {returnTyrePosition(item[0])}：
              </label>

            </div>
            <div className="wheelCarDesc">

              <span style={{ width: '100px', color: returnTyreStatus(item[1].info).color }} className="wheelCarDesc__cnt">
                {returnTyreStatus(item[1].info).text}
              </span>
            </div>

          </div>
          <div style={{ marginTop: index <= 1 ? '22px' : '30px' }}>
            {returnTyreStatus(item[1].info).text == intl.get('txt_zcd') ? returnNomaimg() : returnTyre(item[1].img)}

          </div>
        </div>
      ))}
    </div>
  );
};


{/** 轮胎续航里程 */ }
const Tyre_cllc = props => {
  const _data = props.data;
  let lang = intl.options.currentLocale
  let Ctime = props.time
  let Ctimeuser = Ctime.replace('T', ' ')
  let model = props.model
  let mileageUnit = props.mileageUnit
  let unit = props.unit;
  let wear_threshold = props.wear_threshold;
  _data.lf.position = { left: 10, top: 20 };
  _data.rf.position = { right: 10, top: 20 };
  _data.lb.position = { left: 10, top: lang.includes("zh") ? 200 : 220 };
  _data.rb.position = { right: 10, top: lang.includes("zh") ? 200 : 220 };

  _data.lf.desc = { left: 0, top: lang.includes("zh") ? 70 : 115 };
  _data.rf.desc = { right: 0, top: lang.includes("zh") ? 70 : 115 };
  _data.lb.desc = { left: 0, top: lang.includes("zh") ? -50 : -40 };
  _data.rb.desc = { right: 0, top: lang.includes("zh") ? -50 : -40 };

  // 返回轮胎位置
  const returnTyrePosition = key => {
    switch (key) {
      case "lf":
        return intl.get('txt_zqlun');
      case "lb":
        return intl.get('txt_zhlun');
      case "rf":
        return intl.get('txt_yqlun');
      case "rb":
        return intl.get('txt_yhlun');
    }
  };

  // 返回 信息
  const returnTyreInfo = (data, index) => {
    if (data) {
      return data.split(/,|，/)[index] ? data.split(/,|，/)[index] : "-";
    }
    return "-";
  };


  //返回对应位置轮胎的续航里程图片和文字提示
  const returenImgAndSuggess = (value, key, info, season) => {
    let data = value / 10;
    let temp = returnTyreInfo(info, 0);
    let waishang = returnTyreInfo(info, 3)
    let waishangcd = returnTyreInfo(info, 5)


    let images = key.indexOf('l') !== -1 ? [require(`../../assets/report/litem_2_1.png`),
    require(`../../assets/report/litem_2_2.png`),
    require(`../../assets/report/litem_2_3.png`),
    require(`../../assets/report/litem_2_4.png`),
    require(`../../assets/report/litem_2_5.png`),
    require(`../../assets/report/litem_2_6.png`),
    require(`../../assets/report/litem_2_7.png`),
    require(`../../assets/report/litem_2_8.png`),
    require(`../../assets/report/litem_2_9.png`),
    require(`../../assets/report/litem_2_10.png`)] : [require(`../../assets/report/ritem_2_1.png`),
    require(`../../assets/report/ritem_2_2.png`),
    require(`../../assets/report/ritem_2_3.png`),
    require(`../../assets/report/ritem_2_4.png`),
    require(`../../assets/report/ritem_2_5.png`),
    require(`../../assets/report/ritem_2_6.png`),
    require(`../../assets/report/ritem_2_7.png`),
    require(`../../assets/report/ritem_2_8.png`),
    require(`../../assets/report/ritem_2_9.png`),
    require(`../../assets/report/ritem_2_10.png`),]

    if ((waishang && waishang.indexOf('trauma_normal') == -1) && (waishangcd && waishangcd == 'damage_high')) {
      return {
        text: intl.get('txt_serious_trauma_check'),
        img: returnTyre(images[9])
      }
    }

    if (value < wear_threshold.low) {
      return {
        text: intl.get('txt_msyzljgh'),
        img: returnTyre(images[9])
      }
    }


    if (model == 'dach.tyrescan.ts004') {
      if (season && season == 'season_summer' && value <= 30) {
        return {
          text: intl.get('txt_msyzljgh'),
          img: returnTyre(images[9])
        }
      }
      if (season && season == 'season_winter' && value <= 40) {
        return {
          text: intl.get('txt_msyzljgh'),
          img: returnTyre(images[9])
        }
      }

    }

    if (temp && temp.length >= 3) {

      var tmpdata = temp.slice(2);

      let thatyear = Number(tmpdata) + 2000
      let thatYearOfDay = (temp.length > 3 ? Number(temp.slice(0, 2)) : Number(temp.slice(0, 1))) * 7;
      let current_year = Ctimeuser.slice(0, 4);
      let dateFormat = Ctimeuser.replace(/-/g, '/'); // 将 - 转为 /  // 将-替换成/
      let currentYearOFday = Math.ceil((Date.parse(dateFormat) - new Date(new Date().getFullYear().toString())) / (24 * 60 * 60 * 1000)) + 1

      //每个轮子的使用天数 
      let RemainingDays = (currentYearOFday - thatYearOfDay) + (current_year - thatyear) * 365;
      if (model == 'dt.tyrescan.ts004' && RemainingDays >= 2919) {
        return {
          text: intl.get('txt_tire_age_8'),
          img: returnTyre(images[9])
        }
      }

      if (RemainingDays >= 1820 && model != 'dt.tyrescan.ts004') {
        return {
          text: intl.get('txt_tire_age_5'),
          img: returnTyre(images[9])
        }
      }
    }
    let index, num;
    let str = mileageUnit === 'Miles' ? intl.get('txt_ltlcgsnewin') : intl.get('txt_ltlcgsnew')
    if (data <= 0.8) {
      index = 9
      num = 0
    } else if (data > 0.8 && data <= 1.6) {
      index = 8
      num = 0
    } else if (data > 1.6 && data <= 2.4) {
      index = 7
      num = 1600
    } else if (data > 2.4 && data <= 3.2) {
      index = 6
      num = 11200
    } else if (data > 3.2 && data <= 4) {
      index = 5
      num = 24000
    } else if (data > 4 && data <= 4.8) {
      index = 4
      num = 36800
    } else if (data > 4.8 && data <= 5.6) {
      index = 3
      num = 49600
    } else if (data > 5.6 && data <= 6.4) {
      index = 2
      num = 62400
    } else if (data > 6.4 && data <= 7.1) {
      index = 1
      num = 73600
    } else if (data > 7.1) {
      index = 0
      num = 80000
    }

    num = (value - 25) * 1000
    if (num > 50000) {
      num = 50000
    }

    {/** else {
      num = (value - 16) * 1270
      if (num > 80000) {
        num = 80000
      }
    }*/}

    if (num < 0) {
      num = 0
    }
    
    str = str.replace(new RegExp("\\{" + 0 + "\\}", "g"), num)
    if (num == 0) {
      str = intl.get('txt_msjxtx')
    }

    return {
      text: str,
      img: returnTyre(images[index])
    }

  }


  // 轮胎图片
  const returnTyre = (data) => {

    if (data) {
      return (<img
        style={{
          width: 130,
          height: 40
        }}
        resizemode="contain"
        src={data} />);
    } else {
      return (<div></div>)
    }

  };



  return (
    <div>
      {Object.entries(_data).map((item, index) => (
        <div
          style={Object.assign(item[1].position, { position: "absolute" })}
          key={index}
        >
          <div >
            <div className="wheelCarDesc">
              <label
                className="wheelCarDesc__label"
                style={{
                  width: '100px',

                }}
              >
                {returnTyrePosition(item[0])}：
              </label>

            </div>
            <div className="wheelCarDesc">

              <span style={{ width: '100px', height: lang.includes("zh") ? '60px' : '80px' }} className="wheelCarDesc__cnt">
                {returenImgAndSuggess(item[1].value, item[0], item[1].info, item[1].season).text}
              </span>
            </div>

          </div>
          <div style={Object.assign(item[1].desc, { position: "absolute" })}>
            {returenImgAndSuggess(item[1].value, item[0], item[1].info, item[1].season).img}

          </div>
        </div>
      ))}
    </div>
  );
};





// WEBPACK FOOTER //
// ./src/views/report/Report.jsx